module.exports = __webpack_public_path__ + "img/webhook.33c5b48c.png";